import throttle from 'lodash/throttle';

const $navigation = $('.js-ho-nav');
const $header = $('.js-header');
const $mobileToggle = $('.js-ho-nav-mobile-toggle');
const isMobile = () => window.matchMedia('(max-width: 991px)').matches;
let directionBuffer = [];
let lastScroll = 0;

const updateDirectionBuffer = throttle(() => {
  let direction;

  if (lastScroll < window.pageYOffset) {
    direction = 'DOWN';
  } else if (lastScroll > window.pageYOffset) {
    direction = 'UP';
  }

  if (direction === undefined) {
    return;
  }

  directionBuffer.unshift(direction);

  if (directionBuffer.length > 5) {
    directionBuffer = directionBuffer.slice(0, 5);
  }
}, 35);

if ($navigation && $header && $mobileToggle) {
  bindNavigation();
}

function bindNavigation() {
  window.addEventListener('scroll', () => {
    if (lastScroll < window.pageYOffset) {
      handleScrollDown();
    } else if (lastScroll > window.pageYOffset) {
      handleScrollUp();
    }

    updateDirectionBuffer();
    lastScroll = window.pageYOffset;
  });

  $mobileToggle.on('click', () => {
    $navigation.toggleClass('is-open');
  });

  handleScrollDown();
}

function handleScrollDown() {
  const movingDown = directionBuffer.every(x => x === 'DOWN');
  if (!movingDown) {
    return;
  }

  if (isMobile()) {
    if (!$navigation.hasClass('is-open')) {
      $navigation.removeClass('active');
    }
    return;
  }
  $navigation.removeClass('active');
}

function handleScrollUp() {
  const headerOffset = $header.offset();
  const headerOffsetHeight = headerOffset.top + $header.height();
  if (isMobile()) {
    if (window.pageYOffset < headerOffsetHeight) {
      $navigation.removeClass('is-open');
      $navigation.removeClass('active');
    } else {
      $navigation.addClass('active');
    }
    return;
  }

  if (window.pageYOffset === 0) {
    $navigation.removeClass('active');
    $navigation.removeClass('is-open');
  } else {
    $navigation.addClass('active');
  }
}
